import BaseComponent, { Component, Prop } from '@/mixins/base.component';

import Notification from './notification/notification.vue';
import { NotificationEntity } from '@/types/Notification';

@Component({
   components: { Notification },
})
export default class Notifications extends BaseComponent {
   get notifications(): NotificationEntity[] {
      return this.$store.getters.getActiveNotifications;
   }
}
